import type { RouteObject } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { AppLayout } from './layouts/AppLayout'
import { AuthenticatedLayout } from './layouts/AuthenticatedLayout'
import { OrdersLayout } from './layouts/OrdersLayout'
import { RouteTemplate } from './layouts/RouteTemplate'
import { AuthenticatedFrame, type RouteFrame, type RouteHandle } from './layouts/AuthenticatedFrame'
import { ProtectedRoute } from './auth/ProtectedRoute'
import { GuestRoute } from './auth/GuestRoute'
import { OrdersProfileButton } from '@/pages/Orders/OrdersProfileButton'

const frame = (props: RouteFrame): RouteHandle => ({ frame: props })

export const routes: RouteObject[] = [{
  Component: AppLayout,
  children: [
    {
      Component: ProtectedRoute,
      children: [{
        element: <AuthenticatedLayout><AuthenticatedFrame /></AuthenticatedLayout>,
        children: [
          {
            Component: OrdersLayout,
            handle: frame({ title: 'سفارش', headerEnd: <OrdersProfileButton /> }),
            children: [
              { index: true, lazy: async () => ({ Component: (await import('@/pages/Orders')).default }) },
              { path: 'shipping', lazy: async () => ({ Component: (await import('@/pages/Shipping')).default }) },
            ],
          },
          {
            path: 'profile',
            handle: frame({ title: 'نمایش', back: '/', padded: false, logout: true }),
            lazy: async () => ({ Component: (await import('@/pages/Profile')).default }),
          },
          {
            path: 'profile/show',
            handle: frame({ title: 'اطلاعات حساب', back: '/profile' }),
            lazy: async () => ({ Component: (await import('@/pages/Profile/Showprofile')).default }),
          },
          {
            path: 'profile/comments',
            handle: frame({ title: 'نظر کاربران', back: '/profile', padded: false }),
            lazy: async () => ({ Component: (await import('@/pages/Comments')).default }),
          },
          {
            path: 'profile/estimate',
            handle: frame({ title: 'برنامه هفتگی و تخمین', back: '/profile' }),
            lazy: async () => ({ Component: (await import('@/pages/Estimate')).default }),
          },
          {
            path: 'report',
            handle: frame({ title: 'گزارش', back: '/' }),
            lazy: async () => ({ Component: (await import('@/pages/Reports')).default }),
          },
          {
            path: 'report/penalty',
            handle: frame({ title: 'خطا و جریمه', back: '/report', restoreScroll: false }),
            lazy: async () => ({ Component: (await import('@/pages/Reports/ReportPenalty')).default }),
          },
          {
            path: 'report/archive',
            handle: frame({ title: 'آرشیو سفارش‌ها', back: '/report', restoreScroll: false }),
            lazy: async () => ({ Component: (await import('@/pages/Reports/ReportArchive')).default }),
          },
          {
            path: 'report/score',
            handle: frame({ title: 'امتیاز', back: '/report', restoreScroll: false }),
            lazy: async () => ({ Component: (await import('@/pages/Reports/ReportScore')).default }),
          },
          {
            path: 'report/order',
            handle: frame({ title: 'فروش', back: '/report', restoreScroll: false }),
            lazy: async () => ({ Component: (await import('@/pages/Reports/ReportOrder')).default }),
          },
          {
            path: 'report/order/details',
            handle: frame({ title: 'جزئیات سفارش', orderDetails: true }),
            lazy: async () => ({ Component: (await import('@/pages/Reports/OrderDetails')).default }),
          },
          {
            path: 'profile/food',
            handle: frame({ title: 'غذاها', back: '/profile', padded: false }),
            lazy: async () => ({ Component: (await import('@/pages/Food')).default }),
          },
        ],
      }],
    },
    {
      Component: GuestRoute,
      children: [{ path: 'login', lazy: async () => ({ Component: (await import('@/pages/Login')).default }) }],
    },
    {
      path: '*',
      element: <RouteTemplate title="صفحه پیدا نشد"><p>صفحه موردنظر پیدا نشد.</p><Link to="/">بازگشت به خانه</Link></RouteTemplate>,
    },
  ],
}]
